var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "31px",
    viewBox: "0 0 33 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Verified Client - Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.7255209%",
    y1: "9.76901434%",
    x2: "82.2110136%",
    y2: "87.5265302%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69FEA6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.2--Sign-in-&-Security---2-Factor-A7",
    transform: "translate(-694.000000, -1319.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CA-DMV",
    transform: "translate(694.000000, 1319.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Verified-Client---Check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,31 C6.95455319,31 0,24.0454468 0,15.5 C0,6.95455319 6.95455319,0 15.5,0 C18.3124255,0 21.106383,0.804680851 23.5811064,2.32170213 C24.356766,2.79923404 24.5994894,3.81497872 24.1219574,4.5906383 C23.6444255,5.36629787 22.6286809,5.60638298 21.8556596,5.13412766 C19.9006809,3.93370213 17.7029787,3.29787234 15.5,3.29787234 C8.77234043,3.29787234 3.29787234,8.77234043 3.29787234,15.5 C3.29787234,22.2276596 8.77234043,27.7021277 15.5,27.7021277 C22.2276596,27.7021277 27.7021277,22.2302979 27.7021277,15.5 C27.7021277,14.6214468 27.580766,13.692766 27.332766,12.6638298 C27.1190638,11.7773617 27.6651915,10.8882553 28.5490213,10.6745532 C29.4381277,10.4582128 30.327234,11.0043404 30.5382979,11.8908085 C30.849617,13.1809362 31,14.3602553 31,15.5 C31,24.0454468 24.0454468,31 15.5,31 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7580005,19.5202815 L32.5210381,3.79704746 C33.159654,3.15742274 33.159654,2.11934327 32.5210381,1.47971854 C31.8797941,0.840093819 30.8364587,0.840093819 30.1952148,1.47971854 L15.5964029,16.0442881 L11.8041282,12.258968 C11.1628843,11.6193433 10.1221769,11.6193433 9.48093296,12.258968 C8.83968901,12.8985927 8.83968901,13.9366722 9.48093296,14.5762969 L14.4374333,19.5202815 C14.7580552,19.8400938 15.175915,20 15.5964029,20 C16.0168907,20 16.4373785,19.8400938 16.7580005,19.5202815 Z",
    id: "Path",
    fill: "#273749"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.7ed21f52e90d65cfbafd493a7d599560.svg";
export { ForwardRef as ReactComponent };